import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { HttpParams } from '@angular/common/http';
import { ExportCsvService } from '../../../shared/services/export-csv.service';
import { Router } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { GestaoOnboardingService } from './gestao-onboarding.service';
import { EncriptyUtilService } from '../../../shared/services/encripty-util.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-gestao-onboarding',
  templateUrl: './gestao-onboarding.component.html',
  styleUrls: ['./gestao-onboarding.component.scss']
})
export class GestaoOnboardingComponent implements OnInit {

  public formGestaoOnboarding = null;
  public erroLog = null;
  public rowData: any = [];
  public columnsTabe = null;
  public tableLimit = 12;
  public cnpjCpf = null;
  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();
  public listaProduto: any = [];
  public listEtapa: any = [];
  public listSituacao: any = [];
  public activeStepStatus: boolean = false;
  public customLogin = null;

  constructor(
    private formBuilder: FormBuilder,
    private paginationService: SpringDatatablePaginationService,
    private service: GestaoOnboardingService,
    public exportCsvService: ExportCsvService,
    public router: Router,
    private notificationService: NotificationsService,
    private encriptyService: EncriptyUtilService,
    private spinnerService: NgxSpinnerService,
  ) {

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.columnsTabe = [
      { columnName: "tipoEntidade", newColumnName: "Tipo Entidade" },
      { columnName: "entidadeId", newColumnName: "Entidade ID" },
      { columnName: "cpfCnpj", newColumnName: "cpfCnpj" },
      { columnName: "descricao", newColumnName: "Descricao" },
      { columnName: "tipoIntegracao", newColumnName: "Tipo Integracao" },
      { columnName: "etapaIntegracao", newColumnName: "Etapa Integracao" },
      { columnName: "tentativas", newColumnName: "Tentativas" },
      { columnName: "dataCadastro", newColumnName: "Data Cadastro" },
      { columnName: "dataAtualizacao", newColumnName: "Data Atualizacao" },
      { columnName: "tipoErro", newColumnName: "Tipo Erro" },
      { columnName: "logErro", newColumnName: "Motivo da Falha" },
    ]

    this.listaProduto = [{
      descricao: "AMPLUS",
      label: "AMPLUS"
    }, {
      descricao: "CONTA_PURA",
      label: "CONTA PURA"
    }, {
      descricao: "SALARIO",
      label: "PAGAMENTO"
    }, {
      descricao: "ADIANTA",
      label: "ADIANTA"
    }, {
      descricao: "VIAGEM",
      label: "DESPESAS"
    },
    {
      descricao: "ALIMENTACAO",
      label: "ALIMENTACAO" 
    },
    {
      descricao: "REFEICAO",
      label: "REFEICAO" 
    },
    {
      descricao: "FLEXIVEL",
      label: "FLEXIVEL" 
    },
  ];

    this.listEtapa = [{
      descricao: "cadastro",
      label: "CADASTRO"
    }, {
      descricao: "endereco",
      label: "ENDEREÇO"
    }, {
      descricao: "contato",
      label: "CONTATO"
    }, {
      descricao: "representanteLegal",
      label: "REPRESENTANTE_LEGAL"
    }, {
      descricao: "enriquecimento",
      label: "ENRIQUECIMENTO"
    }, {
      descricao: "verificacao",
      label: "VERIFICACAO"
    }, {
      descricao: "contaPagamento",
      label: "CONTA_PAGAMENTO"
    },
    {
      descricao: "acesso",
      label: "ACESSO"
    },
  ];

    this.listSituacao = [{
      descricao: "PENDENTE",
      label: "PENDENTE"
    }, {
      descricao: "FINALIZADO",
      label: "FINALIZADO"
    }, {
      descricao: "FALHA",
      label: "FALHA"
    },];
  };


  buscar(data?: any, page?: string) {

    let params = new HttpParams();

    params = params.append('size', String(this.tableLimit))
    params = params.append('sort', 'id,asc')

    if (page) {
      params = params.append('page', page)
    }

    if (data.descricao != null) {
      params = params.append('descricao', data.descricao)
    }

    if (data.cnpjCpf != null && data.cnpjCpf !== '') {
      params = params.append('cpfCnpj', this.normalizarCnpjCpfParaBackend(data.cnpjCpf));
    }

    if (data.produto != null) {
      params = params.append('produto', data.produto)
    }

    if (data.etapa != null) {
      params = params.append('etapa', data.etapa)
    }

    if (data.situacao != null) {
      params = params.append('situacao', data.situacao)
    }

    this.spinnerService.show();
    this.service.buscaOnboard(params, (response => {

      this.erroLog = response.content.length;
      response.content.forEach(element => {
        let produto = this.listaProduto.filter(produto => produto.descricao === element.produtoDescricao);
        if (produto != null && produto.length > 0) {
          element.produtoDescricao = produto[0].label;
        }
      });

      this.paginationService.setInfo(response)

      this.spinnerService.hide();
      if (this.erroLog == 0) {
        this.notificationService.warn('Não há dados!');
      }

    }), (erro) => {
      this.spinnerService.hide();
      this.notificationService.warn(erro.message);
    });

  }

  extract(data?: any) {

    let params = new HttpParams();

    if (data.razaoSocial != null) {
      params = params.append('descricao', data.razaoSocial)
    }

    if (data.cnpjCpf != null && data.cnpjCpf !== '') {
      params = params.append('cpfCnpj', this.normalizarCnpjCpfParaBackend(data.cnpjCpf));
    }

    if (data.produto != null) {
      params = params.append('produto', data.produto)
    }

    if (data.etapa != null) {
      params = params.append('etapa', data.etapa)
    }

    if (data.situacao != null) {
      params = params.append('situacao', data.situacao)
    }

    params = params.append('allElements', 'true');
    params = params.append('size', String('199999999'));

    this.service.buscaOnboard(params, (response => {

      this.rowData = response.content
      this.erroLog = response.content.length;

      this.rowData = this.rowData.map(data => {
        return {
          tipoEntidade: data.tipoEntidade,
          entidadeId: data.entidadeId,
          cpfCnpj: data.cpfCnpj,
          descricao: data.descricao,
          tipoIntegracao: data.tipoIntegracao,
          etapaIntegracao: data.etapaIntegracao,
          tentativas: data.tentativas,
          dataCadastro: moment(data.dataCadastro).format('DD/MM/YYYY HH:mm'),
          dataAtualizacao: moment(data.dataAtualizacao).format('DD/MM/YYYY HH:mm'),
          tipoErro: data.tipoErro,
          logErro: data.logErro,
        }
      })

      if (this.erroLog == 0) {
        this.notificationService.warn('Não há dados para exportar!');
      }

      this.exportCsvService.exportCsv(this.rowData, this.columnsTabe, ',', 'erroIntegracao');

    }), null);

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.formGestaoOnboarding = this.formBuilder.group({
      cnpjCpf: [null],
      descricao: [null],
      produto: [null],
      etapa: [null],
      situacao: [null],
    });

  }

  getCpfCnpjMask(): string {
    return DocumentoHelper.getMascaraCpfCnpj(this.cnpjCpf);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) return '';
    const str = String(value);
    if (str === '') return '';
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  openDetails(data: any) {

    let id = this.encriptyService.encriptyBySecretKey('' + data.id)

    let params = {

      'id': id,

    }
    this.router.navigate(['/pages/backoffice/gestao-onboarding-details'], { queryParams: params });

  }

  enableStepStatusField(data: any) {
    if (data != null) {
      this.activeStepStatus = true;
    } else {
      this.activeStepStatus = false;
    }
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}
